import { render, staticRenderFns } from "./ChooseCompany.vue?vue&type=template&id=4aeb465c&scoped=true&"
import script from "./ChooseCompany.vue?vue&type=script&lang=js&"
export * from "./ChooseCompany.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCompany.vue?vue&type=style&index=0&id=4aeb465c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb465c",
  null
  
)

export default component.exports